/*
 * Quick add: update price when the variant changes.
 * No Liquid edit needed — variant data is fetched from /products/<handle>.js.
 * Works for AJAX-loaded cards and quick-add popups (event delegation).
 *
 * Set DEBUG = true to see what it finds in the browser console.
 */
(function () {
  var DEBUG = true;

  // Containers that hold a variant picker + a price
  var CONTAINERS = '.product-item, .card, .product, .halo-popup, .quickshop, [role="dialog"], .modal, form[action*="/cart/add"]';
  var PRICE = '.price, .card-price, .product-price, [data-price]';

  var cache = {};

  function log() { if (DEBUG) console.log.apply(console, ['[variant-price]'].concat([].slice.call(arguments))); }

  function money(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        var fmt = window.money_format || (window.theme && theme.moneyFormat) || Shopify.money_format;
        if (fmt) return Shopify.formatMoney(cents, fmt);
      }
    } catch (e) {}
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: currency }).format(cents / 100);
  }

  // Walk up until we find an ancestor that contains a price element
  function findContainer(el) {
    var node = el.closest(CONTAINERS);
    while (node) {
      if (node.querySelector(PRICE)) return node;
      node = node.parentElement && node.parentElement.closest(CONTAINERS);
    }
    return null;
  }

  function getHandle(container) {
    var withAttr = container.querySelector('[data-product-handle], [data-handle]') ||
                   (container.matches('[data-product-handle], [data-handle]') ? container : null);
    if (withAttr) return withAttr.getAttribute('data-product-handle') || withAttr.getAttribute('data-handle');
    var link = container.querySelector('a[href*="/products/"]');
    if (link) {
      var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }

  function getProduct(handle) {
    if (!cache[handle]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      cache[handle] = fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); });
    }
    return cache[handle];
  }

  function selectedValues(container) {
    var vals = [];
    container.querySelectorAll('input[type="radio"]:checked, select:not([name="id"])').forEach(function (f) {
      if (f.value) vals.push(f.value);
    });
    // Swatch UIs that mark the active one with a class
    if (!vals.length) {
      container.querySelectorAll('.is-active[data-value], .active[data-value], .selected[data-value]').forEach(function (s) {
        vals.push(s.getAttribute('data-value'));
      });
    }
    return vals;
  }

  function findVariant(container, product) {
    var idField = container.querySelector('[name="id"]');
    if (idField && idField.value) {
      var byId = product.variants.find(function (v) { return String(v.id) === String(idField.value); });
      if (byId) return byId;
    }
    var vals = selectedValues(container).map(function (s) { return String(s).trim().toLowerCase(); });
    log('selected values:', vals);
    if (!vals.length) return null;
    return product.variants.find(function (v) {
      var opts = v.options.map(function (o) { return String(o).trim().toLowerCase(); });
      return vals.every(function (val) { return opts.indexOf(val) !== -1; });
    }) || null;
  }

  function render(container, v) {
    var price = container.querySelector(PRICE);
    var onSale = v.compare_at_price && v.compare_at_price > v.price;

    var regular = price.querySelectorAll('.price__regular .price-item--regular');
    var sale = price.querySelector('.price__sale .price-item--sale');
    var compare = price.querySelector('.price__sale .price-item--regular, .price__sale s');

    if (regular.length || sale) {
      regular.forEach(function (el) { el.textContent = money(v.price); });
      if (sale) sale.textContent = money(v.price);
      if (compare) compare.textContent = onSale ? money(v.compare_at_price) : '';
      price.classList.toggle('price--on-sale', !!onSale);
      price.classList.toggle('price--sold-out', !v.available);
    } else {
      price.innerHTML = onSale
        ? '<span class="price-item price-item--sale">' + money(v.price) + '</span> <s class="price-item price-item--regular">' + money(v.compare_at_price) + '</s>'
        : '<span class="price-item price-item--regular">' + money(v.price) + '</span>';
    }
    log('price updated to', money(v.price), 'variant', v.id);
  }

  function handle(e) {
    var container = findContainer(e.target);
    if (!container) { log('no container with a price found for', e.target); return; }
    var h = getHandle(container);
    if (!h) { log('no product handle found in', container); return; }

    // Let the theme's own swatch handler run first
    setTimeout(function () {
      getProduct(h).then(function (product) {
        var v = findVariant(container, product);
        if (!v) { log('no matching variant; option values on product:', product.variants.map(function (x) { return x.options; })); return; }
        render(container, v);
      });
    }, 50);
  }

  document.addEventListener('change', handle, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest('.swatch, .swatch-element, [data-swatch], [data-value], .product-form__input label')) handle(e);
  }, true);

  log('loaded');
})();
